import { render, staticRenderFns } from "./CreateBeaconModal.vue?vue&type=template&id=196564cc&scoped=true&"
import script from "./CreateBeaconModal.vue?vue&type=script&lang=js&"
export * from "./CreateBeaconModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateBeaconModal.vue?vue&type=style&index=0&id=196564cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196564cc",
  null
  
)

export default component.exports